<h5
  class="text-warning text-center m-5"
  *ngIf="
    !activePipeline.child_pipelines || activePipeline.child_pipelines.length == 0
  "
>
  No pipelines.
</h5>
<div
  class="design-list-container"
  *ngIf="
    activePipeline.child_pipelines && activePipeline.child_pipelines.length > 0
  "
>
  <div class="columns" cdkDropListGroup>
    <div
      class="column"
      *ngFor="
        let pipeline of activePipeline.child_pipelines | orderBy: ['order'];
        let i = index
      "
    >
      <h5 class="title">
        <div class="count pull-right">
          <!-- {{ stage.count }} -->
          <button mat-button [matMenuTriggerFor]="stageMenu">
            <i class="flaticon-more-1"></i>
          </button>
          <mat-menu #stageMenu="matMenu">
            <button mat-menu-item (click)="sortPipeline(pipeline)"
              ><i class="fas fa-sort-amount-down"></i> Sort by priority</button
            >
            <!-- <button mat-menu-item (click)="sortStage(stage, 0)"><i class="fas fa-list"></i> Reset sorting</button> -->
          </mat-menu>
        </div>
        <a
          href="javascript:;"
          (click)="setActivePipeline.emit(pipeline.pipeline_id)"
        >
          {{ pipeline.pipeline.label }}
        </a>

        <h6 class="mb-0 p-0">
          <span
            class="pull-right pt-1"
            *ngIf="pipeline.records && pipeline.records.length > 0"
          >
            <b class="text-success"> <i class="fas fa-check-double"></i> </b>
            <span *ngIf="pipeline.completionStatus">
              ({{
                (pipeline.completionStatus.completed /
                  pipeline.completionStatus.total) *
                  100 | currency: ' '
              }}%) |
            </span>
            {{ pipeline.records.length }} CARDS
          </span>
        </h6>
      </h5>

      <div>
        <div class="loading-designs text-center" *ngIf="pipeline.loading"
          ><i class="fas fa-spinner fa-spin"></i> Getting SKUs</div
        >

        <div
          *ngIf="!pipeline.loading"
          [perfectScrollbar]="{ wheelPropagation: true }"
          cdkDropList
          [id]="i"
          class="column-list"
          [cdkDropListData]="pipeline.records"
          (cdkDropListDropped)="drop($event)"
        >
          <div
            class="column-item"
            cdkDrag
            [cdkDragData]="design"
            *ngFor="let design of pipeline.records; let idx = index"
            [ngClass]="getPriorityClass(design, pipeline.pipeline_id)"
          >
            <div class="new-badge" *ngIf="calculateDateDiff(design.created_at) < 6">
              NEW!
            </div>

            <div class="row" *ngIf="design.attachment">
              <div class="col-md-12">
                <div class="text-center">
                  <img [src]="design.attachment" class="img-fluid img-thumbnail" />
                </div>
              </div>
            </div>

            <div class="my-2 product">
              <a
                href="javascript:;"
                title="View Details"
                class="link mr-1"
                (click)="showDetails(design, i)"
              >
                <span
                  class="reference_id"
                  *ngIf="design.reference_id && design.reference_id.length > 1"
                >
                  [{{ design.reference_id }}]
                </span>
                <b>{{ design.design_name }}</b>
              </a>
            </div>

            <div class="action">
              <button mat-button [matMenuTriggerFor]="menu">
                <i class="flaticon-more-1"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editdesign(design, i)"
                  ><i class="fas fa-edit"></i> Edit</button
                >
                <button mat-menu-item (click)="deletedesign(design, i)"
                  ><i class="fas fa-trash text-danger"></i> Delete</button
                >
                <button mat-menu-item (click)="moveToOtherPipeline(design, i)"
                  ><i class="fas fa-stream"></i> Move to Pipelines</button
                >
              </mat-menu>
            </div>

            <div class="row">
              <div class="col-md-8 my-2">
                <div>
                  <span
                    class="due_date"
                    *ngIf="design.due_date"
                    [ngClass]="{
                      due: isDesignDue(design.due_date, design.mark_as_completed),
                      completed: isDesignCompleted(design.mark_as_completed),
                    }"
                  >
                    <i class="far fa-clock"></i>
                    {{ design.due_date | date: 'MMM d' }}
                  </span>

                  <span class="due_date" *ngIf="design.attachments_count">
                    <i class="fa fa-paperclip"></i> {{ design.attachments_count }}
                  </span>

                  <span
                    (click)="showDetails(design, i, 2)"
                    class="due_date completion-status"
                    *ngIf="
                      design.assigned_subtasks &&
                      design.assigned_subtasks.length > 0
                    "
                    [ngClass]="{
                      completed: isDesignSubtaskCompleted(design.assigned_subtasks),
                    }"
                  >
                    <i class="fa fa-check"></i>
                    {{ checkCompleteSubtask(design.assigned_subtasks) }}/{{
                      design.assigned_subtasks.length
                    }}
                  </span>
                  <span
                    class="tags"
                    *ngIf="
                      design.activePipeline &&
                      design.activePipeline.tag_ids &&
                      stage.tags &&
                      stage.tags.length > 0
                    "
                  >
                    <a
                      href="javascript:;"
                      *ngFor="let tag of stage.tags"
                      (click)="toggleTag(tag.id, design.activePipeline)"
                      [title]="tag.tag"
                    >
                      <span
                        [ngStyle]="{
                          color: isTagActive(tag.id, design.activePipeline.tag_ids)
                            ? tag.color
                              ? tag.color
                              : 'green'
                            : '',
                        }"
                      >
                        <mat-icon *ngIf="tag.icon">{{ tag.icon }}</mat-icon>
                        <b *ngIf="!tag.icon">{{ tag.tag[0] }}</b>
                      </span>
                    </a>
                  </span>
                </div>
              </div>
              <div class="col-md-4 my-2">
                <div
                  class="members"
                  *ngIf="design.assigned_users && design.assigned_users.length > 0"
                >
                  <span
                    *ngFor="let assignedUser of design.assigned_users"
                    title="{{
                      assignedUser.user
                        ? assignedUser.user.firstname +
                          ' ' +
                          assignedUser.user.lastname
                        : ''
                    }}"
                  >
                    <span class="user" *ngIf="assignedUser.user">
                      {{
                        (assignedUser.user
                          ? assignedUser.user.firstname.charAt(0)
                          : '') +
                          (assignedUser.user
                            ? assignedUser.user.lastname.charAt(0)
                            : '')
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="mb-2"
              *ngIf="
                design.assigned_subtasks && design.assigned_subtasks.length > 0
              "
            >
              <ng-container
                *ngFor="let subtask of design.assigned_subtasks; let i = index"
              >
                <span
                  class="subtask-icon"
                  [ngStyle]="{ color: subtask.done ? 'green' : '' }"
                  (click)="markSubtaskAsCompleted(design, i, stage)"
                  *ngIf="subtask.icon"
                  [title]="subtask.text"
                >
                  <mat-icon>{{ subtask.icon }}</mat-icon>
                  <!-- <b *ngIf="!subtask.icon"></b> -->
                </span>
              </ng-container>
            </div>
            <div>
              <div class="form-check custom-checkbox">
                <input
                  [(ngModel)]="design.mark_as_completed"
                  (change)="markAsCompleted(design, i)"
                  class="form-check-input mark-as-completed"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault_{{ i + '_' + idx }}"
                />
                <label
                  class="form-check-label"
                  for="flexCheckDefault_{{ i + '_' + idx }}"
                >
                  Mark as Completed
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
